import { render } from "./TallyIntegration.vue?vue&type=template&id=dc5eaa8a"
import script from "./TallyIntegration.vue?vue&type=script&lang=js"
export * from "./TallyIntegration.vue?vue&type=script&lang=js"

import "./TallyIntegration.vue?vue&type=style&index=0&id=dc5eaa8a&lang=css"
script.render = render

export default script